import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetOperacoesByClasseId(operacaoClasseId: string | null) {
  return useQuery([URL.CLASSES_OPERACAO.OPERACOES, operacaoClasseId],
    async () => {
      const { data } = await http.get<any, any>(URL.CLASSES_OPERACAO.OPERACOES, {
        params: {
          operacaoClasseId,
          size: 1000
        },
      });
      return data as any[];
    },
    {
      enabled: !!operacaoClasseId,
    },
  );
}

export default useGetOperacoesByClasseId;
